import React, { useState, useEffect } from 'react';
import { Modal, Button, FormGroup, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    getDeviceCommandList, sendDeviceCommand, sendDeviceCommandResponse,
    clearSendDeviceCommand
} from '../../actions/hardware';
import { parseJSON } from '../../helpers/common';
import { FormValidator } from '../../helpers/form-validator';
import { Form, Heading5, Validator } from '../widgets';

const getValidationRules = () => {
    const isJSONData = value => {
        if (!value) return true;
        const parsedData = parseJSON(value);
        if (parsedData && parsedData !== null) return true;
        else return false;
    };
    const rules = [
        {
            field: 'name',
            method: 'isEmpty',
            validWhen: false,
            message: 'Command is required.',
        },
        {
            field: 'parameters',
            method: isJSONData,
            validWhen: true,
            message: 'Enter valid JSON data.',
        }
    ];
    return rules;
};

const CommandAssignForm = (props) => {
    const { deviceCommandList, onHide, isRequesting, actions, modalInfo: { show, deviceId, deviceName },
        activeCommandInfo: { isRequesting: isSending, activeCommand, activeParameter,
            successMessage, errorMessage, commandResponse } } = props;

    const validator = new FormValidator(getValidationRules());
    const [commandInfo, setCommandInfo] = useState({
        id: null,
        name: "",
        parameters: "",
    });
    const [validationInfo, setValidationInfo] = useState({
        validation: validator.valid(),
        isSubmitted: false,
    });

    useEffect(() => {
        if (deviceCommandList.length === 0)
            actions.getDeviceCommandList();
    }, []);

    useEffect(() => {
        if (!activeCommand) return;

        const aliveCommand = deviceCommandList.filter(e => e.device_command === activeCommand)[0];
        setCommandInfo({
            ...commandInfo, id: aliveCommand ? aliveCommand.device_command_id : null,
            name: aliveCommand ? aliveCommand.device_command : activeCommand,
            parameters: activeParameter ? JSON.stringify(activeParameter) : null
        });
    }, [activeCommand]);

    const handleOnBlur = (e) => {
        if (e.target.value > 0)
            setCommandInfo({ ...commandInfo, name: e.target.value });
    };

    const handleInputChange = (value, event) => {
        if (event.action !== "input-blur" && event.action !== "menu-close") {
            setCommandInfo({ ...commandInfo, id: null, name: value });
        }
    };

    const handleSelect = selectedOption => {
        const { value, label } = selectedOption ? selectedOption : { value: 0, label: '' };
        setCommandInfo({ ...commandInfo, name: label, id: value })
    };

    const handleParameterChange = (e) => setCommandInfo({
        ...commandInfo,
        parameters: e.target.value ? e.target.value : ""
    });

    const handleSend = () => {
        const validation = validator.validate(commandInfo);
        setValidationInfo({ ...validationInfo, validation, isSubmitted: true });

        if (validation.isValid) {
            const reqParams = {
                device_uuid: deviceId,
                command: commandInfo.name.trim(),
                parameter: commandInfo.parameters ? JSON.parse(commandInfo.parameters) : null
            };
            actions.sendDeviceCommand(reqParams);
        }
    };

    const onClose = () => {
        onHide();
        if (!isSending) actions.clearSendDeviceCommand(deviceId);
    };

    const Validation = validationInfo.isSubmitted ? validator.validate(commandInfo) : validationInfo.validation;

    return <Modal show={show} onHide={onClose} backdrop="static" className="command-assign-form">
        <Modal.Header closeButton>
            <Modal.Title >
                <Heading5>
                    {` Send command - ${deviceName}`}
                </Heading5>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {(errorMessage || successMessage) &&
                <Alert
                    show={true}
                    variant={errorMessage ? "danger" : "success"}
                    onClose={() => actions.sendDeviceCommandResponse(deviceId)}
                    dismissible>
                    {errorMessage ? `"${activeCommand}" ${errorMessage}` : `"${activeCommand}"  ${successMessage}`}
                </Alert>}
            {(successMessage && commandResponse) &&
                <pre className="cmd-response">
                    {JSON.stringify(commandResponse, null, 2)}
                </pre>
            }
            <FormGroup>
                <Validator validation={Validation.name}>
                    <Form.Label>Name<Validator.Mand /></Form.Label>
                    <Form.Select
                        name="deviceCommand"
                        className="select-control-lg"
                        value={commandInfo.id}
                        onChange={handleSelect}
                        placeholder={isRequesting ? "Loading..." : "Send command"}
                        options={deviceCommandList.map(e => ({ value: e.device_command_id, label: e.device_command }))}
                        onBlur={handleOnBlur}
                        noOptionsMessage={() => 'Create new command'}
                        inputValue={commandInfo.name}
                        onInputChange={handleInputChange}
                    />
                    <Validator.Text />
                </Validator>
            </FormGroup>
            <Form.Group name="parameters" >
                <Validator validation={Validation.parameters}>
                    <Form.Label>Parameters <span><i className="fa fa-info-circle" /></span></Form.Label>
                    <Form.Control as="textarea" style={{ height: "100px" }}
                        value={commandInfo.parameters} onChange={handleParameterChange} />
                    <Validator.Text />
                </Validator>
            </Form.Group>
        </Modal.Body>
        <Modal.Footer>
            {/* <Button variant="outline-secondary" size="sm" onClick={onHide}>
                Cancel
            </Button> */}
            <Button
                variant="success"
                size="sm"
                onClick={handleSend}
                disabled={isSending || isRequesting}
                className={`send-btn ${(isSending || isRequesting) && 'disable'}`}>
                {!isSending ? "Send" : "Sending..."}
            </Button>
        </Modal.Footer>
    </Modal>
}

const mapStateToProps = (state, { modalInfo }) => ({
    isRequesting: state.hardware.commandList.isRequesting,
    deviceCommandList: state.hardware.commandList.payload,
    activeCommandInfo: state.hardware.sendCommandById[modalInfo.deviceId] ?
        state.hardware.sendCommandById[modalInfo.deviceId] : {},
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getDeviceCommandList, sendDeviceCommand, sendDeviceCommandResponse,
        clearSendDeviceCommand
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CommandAssignForm);